// Replace with the real checkout link when it is available.
export const checkoutUrl = 'https://aprende-coreano-facil.impultienda.ar/checkout';

export const ctaLabel = 'Acceder por $13 solo por hoy';

export const paymentNote =
  'Precio expresado en dólares. El contenido es apto para cualquier persona hispanohablante, así que podés pagar con tu medio de pago local: el checkout convierte automáticamente el precio a tu moneda. Vas a ver el monto final antes de confirmar y recibís el acceso al material por mail.';

export const heroImage = 'https://cdn.magicpatterns.com/uploads/bkRJEMYA1whGnHvRPNi2Wj/mockup-principal.webp';

export const heroMetrics = [
  { value: '6', label: 'Módulos paso a paso' },
  { value: '4', label: 'Bonos incluidos' },
  { value: '+100', label: 'Fichas visuales' },
  { value: '30', label: 'Días de plan guiado' },
];

export const painBefore = [
  'Querés aprender coreano pero no sabés por dónde empezar',
  'Mirás el Hangul y todas las letras te parecen iguales',
  'Sabés palabras sueltas de los K-dramas, pero no podés armar una frase',
  'Estudiás un día, lo olvidás al siguiente y sentís que no avanzás',
  'Saltás entre videos y apps sin un orden claro',
  'Pronunciás con miedo porque no sabés si lo estás diciendo bien',
  'Pensás que "no sos buena/o para los idiomas"',
];

export const painAfter = [
  'Seguís un camino ordenado: primero lo básico, después lo útil y después lo conversacional',
  'Reconocés los patrones del Hangul y leés tus primeras palabras',
  'Construís oraciones con sentido desde muy temprano',
  'Usás técnicas concretas para retener lo que estudiás',
  'Tenés todo en un solo lugar, sin saltar de un recurso a otro',
  'Pronunciás los sonidos esenciales evitando los errores más comunes',
  'Avanzás a tu ritmo con un método pensado para quien empieza de cero',
];

export interface Modulo {
  number: string;
  title: string;
  description: string;
  tag: string;
  coverImage: string;
}

export const modulos: Modulo[] = [
  {
    number: '01',
    title: 'Hangul explicado sin complicarte',
    description:
      'Entendé cómo funciona el alfabeto coreano de forma clara y paso a paso para que puedas leer y escribir con confianza.',
    tag: 'Paso 1 · La base',
    coverImage: 'https://cdn.magicpatterns.com/uploads/mzM9ck3UC8pgE3L9kJdizD/modulo-01.webp',
  },
  {
    number: '02',
    title: 'Pronunciación que sí te suena bien',
    description:
      'Aprendé a producir los sonidos esenciales y evitá los errores más comunes al hablar, incluso si nunca estudiaste idiomas.',
    tag: 'Paso 2 · Sonidos clave',
    coverImage: 'https://cdn.magicpatterns.com/uploads/onLoZrjBUdHWtWYCyD9F18/modulo-02.webp',
  },
  {
    number: '03',
    title: 'Vocabulario esencial',
    description:
      'Las palabras que más se usan en el día a día y en los K-dramas, organizadas para que las aprendas sin abrumarte.',
    tag: 'Paso 3 · Palabras útiles',
    coverImage: 'https://cdn.magicpatterns.com/uploads/eR5geqJvn6utMvUA5PnHKT/modulo-03.webp',
  },
  {
    number: '04',
    title: 'Frases cotidianas y expresiones reales',
    description:
      'Expresiones que aparecen en K-dramas y K-pop para que puedas usar el idioma en situaciones reales.',
    tag: 'Paso 4 · Coreano real',
    coverImage: 'https://cdn.magicpatterns.com/uploads/pihQQQrRtdJL3Chu1RPAd1/modulo-04.webp',
  },
  {
    number: '05',
    title: 'Tus primeras oraciones',
    description:
      'La estructura básica para construir frases con sentido y empezar a comunicarte desde muy temprano.',
    tag: 'Paso 5 · Armar frases',
    coverImage: 'https://cdn.magicpatterns.com/uploads/q4xHAje2Fr9mqarbfDJ7GE/modulo-05.webp',
  },
  {
    number: '06',
    title: 'Memoria y progreso',
    description:
      'Tips concretos para memorizar mejor y retener lo que estudiás, para que no se te olvide al día siguiente.',
    tag: 'Paso 6 · Retención',
    coverImage: 'https://cdn.magicpatterns.com/uploads/w27k38rk2RJiRxi5ktsEVS/modulo-06.webp',
  },
];

export interface Bono {
  badge: string;
  title: string;
  description: string;
  value: string;
  image: string;
}

export const bonos: Bono[] = [
  {
    badge: 'BONO 1',
    title: '+100 Fichas Visuales de Coreano Práctico™',
    description:
      'Un pack de fichas visuales para repasar Hangul, frases básicas, vocabulario cotidiano, expresiones de K-dramas y coreano para viajar. Para estudiar desde el celular, imprimir y practicar paso a paso.',
    value: 'Valor USD 29',
    image: 'https://cdn.magicpatterns.com/uploads/azQJhQb1NmPneYVHa7geqR/bono-1.webp',
  },
  {
    badge: 'BONO 2',
    title: 'Guía Hangul Express™: Aprendé a leer coreano desde cero',
    description:
      'Una guía rápida para entender el alfabeto, reconocer sus letras, comprender cómo se forman las sílabas y leer tus primeras palabras sin sentirte abrumada/o.',
    value: 'Valor USD 12',
    image: 'https://cdn.magicpatterns.com/uploads/azPobzRhhYADv5nHGDPNZf/bono-2.webp',
  },
  {
    badge: 'BONO 3',
    title: 'Frases de K-Dramas y K-Pop™',
    description:
      'Frases y expresiones frecuentes para reconocer palabras en K-dramas, canciones, entrevistas y contenido coreano. Con traducción, romanización y uso práctico.',
    value: 'Valor USD 12',
    image: 'https://cdn.magicpatterns.com/uploads/eqkJiU2EwFeLCsRZET1B3A/bono-3.webp',
  },
  {
    badge: 'BONO 4',
    title: 'Plan 30 Días Coreano Fácil™',
    description:
      'Un calendario de estudio simple para saber qué practicar cada día, crear el hábito y avanzar sin perderte ni abandonar a mitad de camino.',
    value: 'Valor USD 12',
    image: 'https://cdn.magicpatterns.com/uploads/hSHV4tf3mSn4cbGePtrRhN/bono-4.webp',
  },
];

export const valueRows = [
  { label: 'Módulo 1: Hangul explicado', price: 'USD 9' },
  { label: 'Módulo 2: Pronunciación', price: 'USD 9' },
  { label: 'Módulo 3: Vocabulario esencial', price: 'USD 9' },
  { label: 'Módulo 4: Frases cotidianas', price: 'USD 9' },
  { label: 'Módulo 5: Tus primeras oraciones', price: 'USD 9' },
  { label: 'Módulo 6: Memoria y progreso', price: 'USD 9' },
  { label: 'Bono 1: +100 Fichas Visuales', price: 'USD 29' },
  { label: 'Bono 2: Guía Hangul Express', price: 'USD 12' },
  { label: 'Bono 3: Frases de K-Dramas y K-Pop', price: 'USD 12' },
  { label: 'Bono 4: Plan 30 Días', price: 'USD 12' },
];

export const priceTotal = 'USD 119';
export const priceToday = 'USD 13';
export const priceSavings = 'Ahorrás USD 106 (89% OFF)';

// Replace with the final name of the super bonus.
export const superBonoName = 'Audios de Pronunciación Coreano Fácil™';

export const audienceFor = [
  'Querés aprender coreano desde cero, sin experiencia previa',
  'Mirás K-dramas o escuchás K-pop y querés entender más',
  'Nunca estudiaste un idioma y querés un método simple',
  'Preferís un paso a paso ordenado en lugar de contenido suelto',
  'Querés leer Hangul y armar tus primeras frases',
  'Querés estudiar a tu ritmo, desde el celular o impreso',
];

export const audienceNotFor = [
  'Buscás un curso con clases en vivo o certificación oficial',
  'Ya tenés un nivel intermedio o avanzado de coreano',
  'Esperás hablar fluido sin practicar',
  'No estás dispuesta/o a dedicarle unos minutos por día',
];

export interface Testimonial {
  text: string;
  name: string;
  initials: string;
  city?: string;
  role?: string;
}

export const testimonials: Testimonial[] = [
  {
    text: "Yo veía K-dramas y me frustraba porque entendía solo palabras sueltas. Con este método logré leer Hangul sin miedo y empecé a pronunciar frases reales en pocos días. Ahora puedo practicar sin sentir que 'no soy buena para los idiomas'.",
    name: 'María González',
    initials: 'MG',
  },
  {
    text: 'Posta que pensé que el Hangul era imposible y que me iba a costar un huevo. Con las fichas visuales en dos semanas ya estaba leyendo títulos y palabras sueltas de mis doramas favoritos sin subtítulos. El plan de 30 días te salva la vida si no tenés tiempo.',
    name: 'Florencia Martínez',
    initials: 'FM',
  },
  {
    text: 'Venía viendo videos en YouTube pero no cazaba una, sentía que no tenía método. Este ebook va al hueso: te explica la pronunciación sin vueltas y de forma súper gráfica. Re contra vale la pena por lo que cuesta.',
    name: 'Matías Benítez',
    initials: 'MB',
  },
  {
    text: 'Llevaba meses intentando aprender coreano por mi cuenta y me atascaba siempre con las vocales y consonantes dobles. La guía visual es una pasada, súper intuitiva y amena. Por fin entiendo cómo se estructuran las frases sin agobiarme.',
    name: 'Laura Sánchez',
    initials: 'LS',
  },
  {
    text: 'Escucho K-pop a diario y me daba mucha rabia no pillar ni una frase de las canciones. La rutina de 30 días se hace comodísima de seguir después del curro. 100% recomendable para empezar desde cero absoluto.',
    name: 'Javier Gómez',
    initials: 'JG',
  },
  {
    text: 'De verdad que es seco el método. Antes miraba el Hangul y me daba caleta de miedo porque lo encontraba enredado, pero con los dibujos y fichas se hace súper liviano. Ahora cachar las frases de los K-dramas es otra cosa, me encantó.',
    name: 'Camila Rojas',
    initials: 'CR',
  },
  {
    text: 'Buenísimo, al tiro le agarré el hilo. No te meten mil reglas lateras de gramática de entrada, sino que vas aprendiendo a hablar y leer al toque. Los bonos de frases de doramas son la guinda de la torta.',
    name: 'Ignacio Valenzuela',
    initials: 'IV',
  },
  {
    text: "¡Qué purete de curso! Siempre quise aprender coreano pero me daba mba'e miedo no entender nada. Es demasiado claro, visual y fácil de seguir. En menos de un mes ya puedo leer y pronunciar re bien mis primeras oraciones.",
    name: 'Belén Duarte',
    initials: 'BD',
  },
  {
    text: 'La neta superó mis expectativas. Había descargado mil apps que solo te hacen memorizar palabras sin sentido, pero aquí el método visual te aterriza todo súper rápido. Ya no me siento perdida cuando veo series coreanas.',
    name: 'Sofía Morales',
    initials: 'SM',
  },
  {
    text: 'Una maravilla total. El contenido es súper chévere y va directo al grano, no te enreda con explicaciones pesadas. El plan diario de 30 días es perfecto para estudiar un ratico cada día sin estrés. ¡Súper recomendado!',
    name: 'Valentina Restrepo',
    initials: 'VR',
  },
];

export const steps = [
  {
    icon: 'cart',
    number: '01',
    title: 'Hacé el pago',
    description: 'Completá tu compra de forma segura en menos de un minuto.',
  },
  {
    icon: 'download',
    number: '02',
    title: 'Descargá al instante',
    description:
      'Recibís el acceso inmediato al método y los 4 bonos. Sin esperas, desde cualquier dispositivo.',
  },
  {
    icon: 'calendar',
    number: '03',
    title: 'Empezá tu plan de 30 días',
    description:
      'Seguí el método visual paso a paso y leé tus primeras palabras en Hangul desde el primer día.',
  },
] as const;

export const closingIncludes = [
  '6 módulos paso a paso',
  '4 bonos incluidos',
  'Más de 100 fichas visuales',
  'Plan guiado de 30 días',
  'Acceso inmediato y descarga digital',
  'Pago único, sin suscripción',
  'Garantía de 7 días',
];

export interface Notification {
  name: string;
  location: string;
  time: string;
}

export const notifications: Notification[] = [
  { name: 'Valentina R.', location: 'Buenos Aires, Argentina', time: 'hace 2 minutos' },
  { name: 'Daniela M.', location: 'Ciudad de México, México', time: 'hace 5 minutos' },
  { name: 'Carolina S.', location: 'Bogotá, Colombia', time: 'hace 8 minutos' },
  { name: 'Francisca T.', location: 'Santiago, Chile', time: 'hace 11 minutos' },
  { name: 'Alejandra V.', location: 'Lima, Perú', time: 'hace 14 minutos' },
  { name: 'Mariana F.', location: 'Montevideo, Uruguay', time: 'hace 18 minutos' },
  { name: 'Gabriela P.', location: 'Caracas, Venezuela', time: 'hace 22 minutos' },
  { name: 'Sofía R.', location: 'Rosario, Argentina', time: 'hace 26 minutos' },
  { name: 'Camila V.', location: 'Guadalajara, México', time: 'hace 31 minutos' },
  { name: 'Isabella M.', location: 'Medellín, Colombia', time: 'hace 35 minutos' },
  { name: 'Catalina R.', location: 'Valparaíso, Chile', time: 'hace 41 minutos' },
  { name: 'Luciana B.', location: 'Córdoba, Argentina', time: 'hace 47 minutos' },
  { name: 'Andrea C.', location: 'Quito, Ecuador', time: 'hace 58 minutos' },
  { name: 'Jimena P.', location: 'Asunción, Paraguay', time: 'hace 1 hora' },
  { name: 'Natalia F.', location: 'La Paz, Bolivia', time: 'hace 1 hora y 8 min' },
  { name: 'Paola M.', location: 'San José, Costa Rica', time: 'hace 1 hora y 15 min' },
  { name: 'Valeria T.', location: 'Guatemala, Guatemala', time: 'hace 1 hora y 24 min' },
  { name: 'Mónica R.', location: 'Mendoza, Argentina', time: 'hace 1 hora y 33 min' },
];

export const faqs = [
  {
    question: '¿Es para principiantes reales?',
    answer: 'Sí. Está pensado para quien empieza de cero, incluso si nunca estudió otro idioma.',
  },
  {
    question: '¿Puedo aprender aunque no tenga buena base en idiomas?',
    answer:
      'Sí. El método es visual y va paso a paso: primero lo básico, después lo útil y después lo conversacional.',
  },
  {
    question: '¿Cómo recibo el material después de comprar?',
    answer: 'Recibís el acceso apenas se confirma el pago. Sin esperas y desde cualquier dispositivo.',
  },
  {
    question: '¿El pago es único o es una suscripción?',
    answer: 'Es un pago único. Sin cuotas mensuales ni cargos extra. El acceso es de por vida.',
  },
  {
    question: '¿Incluye pronunciación y cómo evitar errores?',
    answer: 'Sí. El módulo de pronunciación te enseña los sonidos esenciales y los errores más comunes al hablar.',
  },
  {
    question: '¿Qué pasa si no me sirve?',
    answer: 'Tenés 7 días de garantía. Si no es para vos, te devolvemos el 100% de tu dinero.',
  },
];
